import { USER_PERMISSION } from "./USER_PERMISSION";

export default function isNormal(userPermissions: AccountPermissions.AgnosticPermission): boolean {
  if (userPermissions.level === USER_PERMISSION.NORMAL) {
    return true;
  }
  return false;
}
